/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 17/09/2024 | Lic. José Luis Aragón Cervantes  | Creación
* --------------------------------------------------------------------------------------- */

import { Grid, Typography } from "@mui/material";
import Modal from "../../../components/utils/Modal";
import { useArticulos } from "../../../context/Catalogos/ArticulosContext";

export default function ArticulosEliminar() {
    const { 
      statusOpenModalEliminarArticulo: modalOpenEliminarArticulos,
      handleCloseEliminarArticulos,
      handleSubmitEliminarArticulos 
    } = useArticulos();
  
    return (
      <Modal
        open={Boolean(modalOpenEliminarArticulos)}
        title={"Eliminar artículo"}
        onClose={handleCloseEliminarArticulos}
        onSuccess={handleSubmitEliminarArticulos}
        success="Eliminar"
      >
        <Grid container>
          <Grid item xs={12}>
            <Typography>¿Desea eliminar el autobús seleccionado?</Typography>
          </Grid>
        </Grid>
      </Modal>
    );
  }
  